var _rect, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 10,
    height: 4,
    fill: "#929292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22V8L24 15L16 22Z",
    fill: "#929292"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginNext);
export default __webpack_public_path__ + "static/media/loginNext.c457e05c8fcda90af0a4c0c1fa4fd362.svg";
export { ForwardRef as ReactComponent };